import React, {useEffect, useState} from "react";
import {Grid, List, ListItemButton, ListItemText, Divider} from "@mui/material";
import {useTranslation} from "react-i18next";
import {findSimilar} from "../../api/questionAPIs";
import {comparedTextAtom} from "../../atoms/useComparedTextAtom";
import {useAtom} from "jotai";

const Chapters = ({
                      sourceText, onChapterSelect = (chapter) => {
    }
                  }) => {
    const [t,] = useTranslation('global');
    const [chapters, setChapters] = useState([]);
    const [comparedText, setComparedText] = useAtom(comparedTextAtom);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedChapter, setSelectedChapter] = useState(undefined)

    useEffect(() => {
        setIsLoading(true);
        findSimilarChapters(sourceText)
            .then(response => {
                setChapters(response);
            })
            .finally(() => {
                setIsLoading(false);
            });


    }, [sourceText])


    const handleChapterSelect = (chapter, index) => {
        setIsLoading(true);
        setComparedText(chapter.Chunk);
        setSelectedChapter(index);
        onChapterSelect(chapter);
        setIsLoading(false);
    }


    const findSimilarChapters = async (text) => {
        console.log('findSimilarChapters', text);
        if (!text) return [];

        const response = await findSimilar(text);
        console.log('response', response);
        return response;
        /*return {
            Intent: 'FindSimilar',
            Data: [
                {
                    Metadata: {
                        chapter: 'kapitola 1',
                        f: 'normy.xlsx',
                        norm: 'norma 1'
                    },
                    Chunk: 'sdfsdfg sdf gsdgsd ',
                    Distance: 0.3297605
                },
                {
                    Metadata: {
                        chapter: 'kapitol 2 ',
                        f: 'normy.xlsx',
                        norm: 'norma 1'
                    },
                    Chunk: 'dfg sdfgs f ',
                    Distance: 0.33862743
                }
            ],
            Status: 'OK'
        }*/
    }

    const renderChapter = (chapter, index) => {
        return (
            <React.Fragment key={index}>
                <ListItemButton className='chapter-item' key={index} selected={index === selectedChapter}>
                    <ListItemText
                        disableTypography={true}
                        primary={<span style={{fontSize: '16px', color: 'black'}}>
                            {chapter.Metadata.normNumber} - {chapter.Metadata.norm} - {chapter.Metadata.chapter}
                        </span>}
                        secondary={
                            <div style={{fontSize: '14px', color: 'black'}}>
                                <div>{chapter.Metadata.f}</div>
                                <div>{parseFloat(chapter.Distance?.toString() ?? '0').toFixed(2)}</div>
                            </div>
                        }
                        onClick={() => handleChapterSelect(chapter, index)}
                    />
                </ListItemButton>
                <Divider className="chapters-divider" variant="middle" component="li"/>
            </React.Fragment>
        )
    }


    return (
        isLoading ? null :
            <div className="chapters-container">
                <Grid container spacing={2}>
                    <Grid item xs={12} className="chapters-title">
                        <h2>{t('chapters.title')}</h2>
                    </Grid>
                    <Grid item xs={12} className={chapters.length > 0 ? "chapters-list" : "chapters-trnsp"}>
                        <List sx={{width: '100%'}}>
                            {chapters && chapters.map((chapter, index) => renderChapter(chapter, index))}
                        </List>
                    </Grid>
                </Grid>
            </div>
    );
}

export default Chapters;